module Easypass {
    export enum TypeTransaction {
		Rechargement = 1,
		PaiementCommande = 2,
		PaiementDinerTakeAwayCommande = 3
    }
}